<template>
  <div style="height: 150vh;" class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <!-- desktop >768px md -->
    <div class="desktop "></div>
    <!-- end of desktop -->

    <!-- mobile <768px xs-->
    <div class="mobile">
      <el-row style="padding: 60px 15px 100px 15px;" class="full-width">
        <el-col :xs="24" :sm="16" :md="16" :lg="16">
          <div style="padding-top: 10px" class="full-width">
            <p style="font-weight: 600; font-size: 12px">
              {{ $t("titleTermsAndConditions1") }}
            </p>
            <div>
              <p style="font-size: 12px">
                {{ $t("contentTermsAndConditions11") }}
              </p>
              <p style="font-size: 12px">
                {{ $t("contentTermsAndConditions12") }}
              </p>
              <p style="font-size: 12px">
                {{ $t("contentTermsAndConditions13") }}
              </p>
            </div>

            <p style="font-weight: 600; font-size: 12px">
              {{ $t("titleTermsAndConditions2") }}
            </p>
            <div>
              <p style="font-size: 12px">
                {{ $t("contentTermsAndConditions21") }}
              </p>
              <p style="font-size: 12px">
                {{ $t("contentTermsAndConditions22") }}
              </p>
              <p style="font-size: 12px">
                {{ $t("contentTermsAndConditions23") }}
              </p>
              <p style="font-size: 12px">
                {{ $t("contentTermsAndConditions24") }}
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "../../../layout/WapV2/MainNavBar.vue";
import { getBackGround } from "../../../utils/wapAuth";
import SearchIcon from "@/assets/img/svg/searchIcon.svg";
import CloseIcon from "@/assets/img/svg/close-icon.svg";
import GlobalAPI from "@/views/api/wapV2/global";
import { isEmpty } from "@/utils/validate";

export default {
  components: {
    MainNavBarWapV2
  },
  bodyClass: "search-facility",
  props: {},

  created() {
    this.onGetFacility();
  },
  data() {
    return {
      facilityName: "",
      listFacility: [],
      infoHeader: {
        title: this.$t("termsAndConditions"),
        isShowHomeIcon: false
      },
      bg: getBackGround(),
      icons: {
        SearchIcon,
        CloseIcon
      }
    };
  },
  watch: {},
  methods: {
    async onGetFacility() {
      const { data, error_code } = await GlobalAPI.searchFacility({
        q: "c"
      });
      if (error_code === 0) this.listFacility = data;
    },
    async handleSearchFacility(val) {
      if (isEmpty(val)) {
        await this.onGetFacility();
        return;
      }
      const { data, error_code } = await GlobalAPI.searchFacility({
        q: val.trim()
      });
      if (error_code === 0) this.listFacility = data;
    }
  }
};
</script>
<style></style>

<style scoped>
.golfContainer {
}
.search-bar-container {
  background: #dee0e2;
  border-radius: 100px;
  height: 40px;
  display: flex;
  align-items: center;
}
.info-golf-course {
  position: relative;
  padding-right: 20px;
  border-bottom: 1px solid #a3a3a3;
  padding-bottom: 10px;
}
.address-course {
  color: #999999;
  font-size: 12px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}
.name-course {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  color: black;
  font-weight: 500;
  font-size: 14px;
  max-width: 90%;
}
.golf-course {
  overflow: hidden;
  padding: 0;
  display: flex;
  margin-bottom: 20px;
}
.px-15 {
  padding: 0 15px;
}

.divider-view {
  height: 10px !important;
  width: 100%;
  background-color: #e3e3e3;
  margin: 30px 0;
}

.top-spacing {
  padding-top: 100px;
}

.divider-view {
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ececec;
}

.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mr-10 {
  margin-right: 10px;
}

.ml-10 {
  margin-left: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.ml-4 {
  margin-left: 4px;
}
.flex-grow {
  flex-grow: 1;
}

.pt-12 {
  padding-top: 12px;
}
.pb-0 {
  margin-bottom: 0px;
}
.pb-80 {
  padding-bottom: 80px;
}
.mt-36 {
  margin-top: 36px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
}
</style>

<style lang="scss" scoped>
$divider-color: #d9d9d9;

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 769px) and (max-width: 980px) {
  .top-spacing {
    padding-top: 70px !important;
  }
}
</style>
